/**
 * <Schedule
 *		// please describe props here
 *	/>
 *
 * This is ...
 *
 * @parent routes
 * @children
 * @stateful
 * @stateless
 * @redux
 */
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { PanelWrapper } from 'components/UI';
import find from 'lodash/find'

import { fetchSchedule } from './ducks.js';

import { alert } from 'util/alert';

import Toolbar from './Toolbar';

import './Schedule.scss';

import moment from 'moment';

import ClassCalendar from 'template/ClassCalendar';

import getScheduleOption from './getScheduleOption';
import convertScheduleToRbcEvents from './convertScheduleToRbcEvents.js';

import updateLessonWithTime from 'controllers/lesson/updateLessonWithTime';

import getLessonStudentList from 'controllers/lesson/getLessonStudentList';

import Lesson from 'mediators/Lesson'

import { getDay, getTimeIn24 } from 'util/datetime'

const mapStateToProps = state => ({
  schedule: state.schedule,
});

const DEFAULT_VIEW_DATE = new Date();

class Schedule extends React.Component {
  constructor(props) {
    super(props);

    this._transformEvents = this._transformEvents.bind(this);

    this.fetchScheduleFromServer = this.fetchScheduleFromServer.bind(this);

    this.moveEvent = this.moveEvent.bind(this);

    this.onNavigate = this.onNavigate.bind(this);

    const {
      scheduleOption,
    } = this.props;

    this.state = {
      scheduleOption: scheduleOption || getScheduleOption(new Date()),
      events: [],
      date: DEFAULT_VIEW_DATE,
    }
  }

  _transformEvents(props) {
    const {
      schedule,
    } = props;

    const {
      teacher: teacherForFiltering,
      student: studentForFiltering,
      classroom: classroomForFiltering,
      class: classForFiltering,
    } = schedule.filterData;

    const {
      loggedinTeacherId,
    } = schedule

    //
    // STEP 1. Filtering
    //
    // Loop through all the events and if any filtering criteria
    // are not fulfilled, we will filter it out because the condition
    // is &&.
    //
    // An event is actually a lesson, for now. In the future,
    // there will be more 'events' other than a lesson
    //
    // When we filter by student which is slightly different from the above.
    // studentForFiltering is fetched from getTimetable API and we will
    // have to filter out of studentForFiltering.
    //
    let eventsToFilter;
    if (studentForFiltering) {
      eventsToFilter = studentForFiltering.events;
    } else if (teacherForFiltering) {
      eventsToFilter = teacherForFiltering.events;
    } else {
      eventsToFilter = schedule.events;
    }

    let events = eventsToFilter.filter((evt)=>{
      let toInclude = true;

      if (classForFiltering && classForFiltering.IDs.length > 0) {
        if (classForFiltering.IDs.indexOf(evt.lClass) === -1) {
          return false;
        }
      }

      if (classroomForFiltering && classroomForFiltering.IDs.length > 0) {
        if (classroomForFiltering.IDs.indexOf(evt.lClassroom) === -1) {
          return false;
        }
      }

      return toInclude;
    });

    //
    // STEP 2. Trandform
    //
    // We must chage the schedule into a format react-big-calendar would understand.
    //
    events = convertScheduleToRbcEvents(events);

    //
    // STEP 3. Update to state to reflect the change in DOM
    //
    this.setState({
      events
    });
  }

  alreadyCheckedInAlert() {
    alert.warning(__('Attended lesson cannot be moved', 'schedule'));
  }

  conflictedEventAlert(conflicts) {
    alert.warning(
      __('There was a conflict while moving the lesson.', 'schedule')
      , __('Conflicts', 'schedule'));
  }

  moveEvent({ event, start, end }) {
    if (event.lState === 1) {
      this.alreadyCheckedInAlert();
      return;
    }

    const lesson = new Lesson(event);

    const {
      name, classroomId, calendarColor,
    } = lesson;

    let params = {
      new_name: name,
      start_datetime: getDay(start) + ' ' + getTimeIn24(start).split(' ')[0],
      end_datetime: getDay(end) + ' ' + getTimeIn24(end).split(' ')[0],
      classroom_id: classroomId ? Number(classroomId) : '',
      calendar_color: calendarColor,
      student_id_list: [],
      teacher_id_list: lesson.getTeacherIdList(),
    }

    // We need to load up student list inside the lesson
    // since lesson doesn't come with it
    getLessonStudentList(event.id)
      .then(({student_list})=>{
        let studentIdList = [];
        if (student_list) {
          studentIdList = student_list.map((student)=>{
            return student.student_id;
          })
        }

        params.student_id_list = studentIdList;

        updateLessonWithTime(event.id, params)
          .then(({data})=>{
            // CASE 1. Lesson has already been checked in
            if (data.reason && data.reason.indexOf('checked in') > -1) {
              this.alreadyCheckedInAlert();
              return;
            }

            // CASE 2. Conflicts
            if (data.conflicted_result === true) {
              this.conflictedEventAlert(data);
              return;
            }

            // CASE 3. all good, it moved, let's fetch the new data
            this.fetchScheduleFromServer();
          })
          .catch((err)=>{
            console.error(err);
          });

      });


  }

  onNavigate(dateIn) {
    let date;
    if (typeof dateIn === 'string') {
      date = moment(dateIn, 'YYYY-MM-DD hh:mm:ss').toDate();
    } else if (dateIn instanceof Date) {
      date = dateIn;
    }

    if (date !== this.state.date) {
      this.setState({
        scheduleOption: getScheduleOption(date),
        date: date || this.state.date, // if date is empty, we use original data in stata
      }, ()=>{
        this.fetchScheduleFromServer();
      });
    }
  }

  componentWillMount() {
    this.fetchScheduleFromServer();
  }

  fetchScheduleFromServer() {
    let {
      dispatch
    } = this.props;

    let {
      scheduleOption,
    } = this.state;

    let schoolId = localStorage.getItem('schoolId');

    dispatch(fetchSchedule(schoolId, scheduleOption));
  }

  componentWillReceiveProps(nextProps) {
    this._transformEvents(nextProps);
  }

  render() {
    const {
      events,
      date,
    } = this.state;

    let {
      fetching,
    } = this.props.schedule;

    return (
      <PanelWrapper>
        <div>
					{__('Schedules', 'header.sidemenu')}
        </div>
        <ClassCalendar
          fetching={fetching}
          events={events}
          timeslots={4}
          date={date}
          components={{
            toolbar: Toolbar
          }}
          onEventDrop={this.moveEvent}
          onNavigate={this.onNavigate}
        />
      </PanelWrapper>
    )
  }
}

export default connect(mapStateToProps)(Schedule);



// WEBPACK FOOTER //
// ./src/containers/pages/Schedule/Schedule.js